import React from 'react';
import QuizEditorContainer from '../../molecules/Editor/QuizEditorContainer';
import Presenter from './Presenter';
import MobilePresenter from './MobilePresenter';
import Container from './Container';
import { Mobile, Default } from '../../Sizes';

const DemoContent = (props) => {
	return (<QuizEditorContainer
		initText={'1+%A{1}=2\n東京オリンピックは%A{2020}年に開催される'}
		render={({ editorProps : editor, plainText }) => {
			return <Container
				editText={plainText}
				editorProps={editor}
				{...props}
				render={({
					previewProps,
					editorProps,
				},other) => {
					return (
						<React.Fragment>
							<Default>
								<Presenter
									editorProps={editorProps}
									previewProps={previewProps}
									{...other}
								/>
							</Default>
							<Mobile>
								<MobilePresenter 
									editorProps={editorProps}
									previewProps={previewProps}
									{...other}
								/>
							</Mobile>
						</React.Fragment>
					);
				}}
			/>;
		}}
	/>);
};


DemoContent.propTypes = {
};

export default DemoContent;